import {Injectable} from '@angular/core';

@Injectable()
export class DefaultValuesService {

    public toDoCategoryConfiguration = [
        {
            toDoType: 'INCOMPLETE_ASSESSMENT',
            dataSource: 'Inbox',
            screenDisplay: 'Incomplete',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 2,
            forwardTo: (item) => {
                let forward = this.assessmentForwardUrl(item.type) + item.assessmentId;
                if (item.interviewId) {
                    forward += '/' + item.interviewId;
                }
                return forward;
            }
        },
        {
            toDoType: 'INCOMPLETE_EPISODE_ASSESSMENT',
            screenDisplay: 'Incomplete',
            dataSource: 'Inbox',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 2,
            forwardTo: (item) => {
                let forward = this.assessmentForwardUrl(item.type) + item.assessmentId;
                if (item.interviewId) {
                    forward += '/' + item.interviewId;
                }
                return forward;
            }
        },
        {
            toDoType: 'INITIAL_ASSESSMENT_UPCOMING',
            screenDisplay: 'Initial Upcoming',
            dataSource: 'Inbox',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 1,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'TICKLER_INITIAL_UPCOMING',
            screenDisplay: 'Initial Upcoming',
            dataSource: 'Tickler',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 1,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'INITIAL_ASSESSMENT_OVERDUE',
            screenDisplay: 'Initial Overdue',
            dataSource: 'Inbox',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 2,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'TICKLER_INITIAL_OVERDUE',
            screenDisplay: 'Initial Overdue',
            dataSource: 'Tickler',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 2,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'UPDATE_ASSESSMENT_UPCOMING',
            screenDisplay: 'Update Upcoming',
            dataSource: 'Inbox',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 1,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'TICKLER_UPDATE_UPCOMING',
            screenDisplay: 'Update Upcoming',
            dataSource: 'Tickler',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 1,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'UPDATE_ASSESSMENT_OVERDUE_LVL1',
            screenDisplay: 'Update Overdue',
            dataSource: 'Inbox',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 2,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'UPDATE_ASSESSMENT_OVERDUE_LVL2',
            screenDisplay: 'Update Overdue',
            dataSource: 'Inbox',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 2,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'TICKLER_UPDATE_OVERDUE',
            screenDisplay: 'Update Overdue',
            dataSource: 'Tickler',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 2,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'CLOSED_PLACEMENT_DISCHARGE_OVERDUE',
            screenDisplay: 'Discharge Overdue',
            dataSource: 'Inbox',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 2,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'TICKLER_DISCHARGE_UPCOMING',
            screenDisplay: 'Discharge Upcoming',
            dataSource: 'Tickler',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 1,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'TICKLER_DISCHARGE_OVERDUE',
            screenDisplay: 'Discharge Overdue',
            dataSource: 'Tickler',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 2,
            forwardTo: (item) => {
                return 'data_entry/assessments/' + item.clientId;
            }
        },
        {
            toDoType: 'RETURNED_ASSESSMENT',
            screenDisplay: 'Returned',
            dataSource: 'Inbox',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 2,
            forwardTo: (item) => {
                let forward = this.assessmentForwardUrl(item.type) + item.assessmentId;
                if (item.interviewId) {
                    forward += '/' + item.interviewId;
                }
                return forward;
            }
        },
        {
            toDoType: 'ASSESSMENT_PENDING_APPROVAL',
            screenDisplay: 'Pending Approval',
            dataSource: 'Inbox',
            result: [],
            originalCount: 0,
            pageCnt: 1,
            count: 0,
            loaded: false,
            display: false,
            severity: 2,
            permission: 'CANS_APPROVE',
            forwardTo: (item) => {
                let forward = this.assessmentForwardUrl(item.type) + item.assessmentId;
                if (item.interviewId) {
                    forward += '/' + item.interviewId;
                }
                return forward;
            }
        }
    ];

    assessmentForwardUrl(instrumentType) {
        switch (instrumentType) {
            case 'CANS':
            case 'ANSA':
                return 'data_entry/assessmentc/';
                break;
            case 'ACE':
            case 'ASQ':
            case 'BRIEFP':
            case 'DAYC2':
            case 'ECBI':
            case 'PDMS2':
            case 'PSISF':
            case 'SPMP':
            case 'TSCYC':
                return 'data_entry/assessmentad/';
                break;
            case 'PSC':
                return 'data_entry/assessmentpsc/';
                break;
            default:
                return 'data_entry/assessment/';
                break;
        }
    };

    constructor() {
    }
}
